<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <CreateTicketBubble v-if="!excludedRoutes.includes($route.name)"/>
    <notifications transition-name="notification-list" transition-mode="out-in" />

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <!-- MODAL GLOBAL UNIVERSAL -->
    <transition name="slide-right">
      <GlobalModal
        v-if="modalComponent"
        @close="closeModal"
      >
        <!-- Breadcrumb informativ sus (fără link-uri) -->
        <div v-if="modalProps.route" class="modal-breadcrumb-info">
          <span class="breadcrumb-item">{{ $t('general.home') }}</span>
          <span v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-separator">
            › <span class="breadcrumb-item">{{ crumb.name }}</span>
          </span>
        </div>

        <component :is="modalComponent" v-bind="modalProps" @close="closeModal" />
      </GlobalModal>
    </transition>

    <div v-if="loadingView" class="global-loader">
      <div class="spinner"></div>
      <p>{{ $t('general.generalLoader') }}</p>
    </div>
  </div>
</template>

<script>
import CreateTicketBubble from 'src/components/UIComponents/CreateTicketBubble.vue'
import GlobalModal from 'src/components/UIComponents/GlobalModal.vue'

export default {
  components: { CreateTicketBubble, GlobalModal },
  data () {
    return {
      excludedRoutes: ['Orders', 'Reports'],
      modalComponent: null,
      modalProps: {},
      loadingView: false,
      modalId: null
    }
  },
  computed: {
    breadcrumbs () {
      if (!this.modalProps.route) return []
      const paths = this.modalProps.route.path.split('/').filter(p => p)
      return paths.map((p, i) => ({
        name: p.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
        path: '/' + paths.slice(0, i + 1).join('/')
      }))
    }
  },
  created () {
    this.$bus.$on('open-modal', async ({ id, component, props }) => {
      this.modalComponent = null
      this.modalProps = {}
      this.modalId = null

      await this.$nextTick()

      setTimeout(() => {
        this.modalId = id
        this.modalComponent = component
        this.modalProps = props
      }, 0)
    })
    this.$bus.$on('close-modal', (id) => {
      if (!id || id === this.modalId) {
        this.modalComponent = null
        this.modalProps = {}
        this.modalId = null
      }
    })
    this.$bus.$on('set-loading', (status) => {
      this.loadingView = status
    })
  },
  methods: {
    breadcrumbLabel (segment) {
      const labels = {
        reports: 'pages.reports',
        'referral-program': 'reports.referralProgramReport',
        ambassador: 'referralProgram.ambassadorId'
      }
      if (labels[segment]) {
        return this.$t(labels[segment])
      }
      if (/^\d+$/.test(segment)) {
        return null
      }
      return segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
    closeModal () {
      this.$bus.$emit('close-modal')
    },
    setLoading (status) {
      this.loadingView = status
    }
  }
}
</script>

<style>
/* Breadcrumb vizual, fain și informativ */
.modal-breadcrumb-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #25396F;
  margin-bottom: 16px;
  background: #F4F6FF;
  padding: 8px 16px;
  border-radius: 8px;
}

.breadcrumb-item {
  white-space: nowrap;
  margin-left: 5px;
}

.breadcrumb-separator {
  display: flex;
  align-items: center;
  margin-left: 6px;
  color: #25396F;
}

/* Restul stilurilor modal și loader rămân neschimbate */
.slide-right-enter-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-right-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-right-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-right-enter-to {
  transform: translateX(0);
  opacity: 1;
}
.slide-right-leave {
  transform: translateX(0);
  opacity: 1;
}
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Loader global fancy */
.global-loader {
  position: fixed;
  inset: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Arial', sans-serif;
  color: #fff;
  pointer-events: all;
}

.global-loader p {
  margin-top: 16px;
  font-size: 1.2em;
  letter-spacing: 0.5px;
  animation: pulse 1.5s infinite;
}

.spinner {
  width: 64px;
  height: 64px;
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top: 8px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
</style>



// WEBPACK FOOTER //
// src/App.vue